<template>
  <div>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-btn text icon color="green">
        <v-icon @click="$router.push('defTextDet')">mdi-keyboard-backspace</v-icon>
      </v-btn>
      <v-toolbar-title class="toolbar-title-custom">Default Text: {{ this.ids.scrRef }} - {{ this.ids.txtRef }}</v-toolbar-title>
    </v-toolbar>
    <v-flex xs12>
      <v-tabs v-model="tabValue" slider-color="primary">
        <v-tab @click="resetTab">Listing</v-tab>
        <v-tab v-show="review">Action</v-tab>
        <v-tab-item>
          <pol-type-def-txt-list ref="list" :id="ids" query @query="doQuery($event)" @new="doNew" @review="doReview($event)"></pol-type-def-txt-list>
        </v-tab-item>
        <v-tab-item v-show="review">
          <pol-type-def-txt-form
            :key="review"
            :tranMode="tranMode"
            :newPolTypeDefTxt="newPolTypeDefTxt"
            :id="ids"
            @close="resetTab"
            @fetch="$refs.list.fetchData(false)"
          ></pol-type-def-txt-form>
        </v-tab-item>
      </v-tabs>
    </v-flex>
  </div>
</template>

<script>
import PolTypeDefTxtList from './list/PolTypeDefTxtList'
import PolTypeDefTxtForm from './form/PolTypeDefTxtForm'
export default {
  data() {
    return {
      tabValue: 0,
      review: false,
      newPolTypeDefTxt: false,
      ids: {
        scrRef: null,
        txtRef: null,
        polType: null
      },
      tranMode: null
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const scrRef = vm.id.split('_')[0]
      if (!vm.polTypeDefTxtValid.includes(scrRef)) {
        vm.$snotify.error('Screen Reference is not eligible to access this site')
        vm.$router.push({
          name: 'defTextDet',
          params: {
            id: vm.id
          }
        })
      }
    })
  },
  created() {
    const id = this.id.split('_')
    this.ids.scrRef = id[0]
    this.ids.txtRef = id[1]
  },
  mounted() {},
  methods: {
    resetTab() {
      this.tabValue = 0
      this.review = false
      this.newPolTypeDefTxt = false
    },
    doNew() {
      this.tabValue = 1
      this.review = true
      this.newPolTypeDefTxt = true
      this.tranMode = 'New'
    },
    doReview(data) {
      if (data) {
        this.ids.polType = data.polType
        this.tabValue = 1
        this.review = true
        this.tranMode = 'Review'
      }
    },
    doQuery(data) {
      if (data) {
        this.ids.polType = data.polType
        this.tabValue = 1
        this.review = true
        this.tranMode = 'Query'
      }
    }
  },
  computed: {
    polTypeDefTxtValid: () => ['01', '02', '03', '04', '05', '10', '11']
  },
  components: {
    PolTypeDefTxtList,
    PolTypeDefTxtForm
  },
  props: ['id']
}
</script>

<style>
</style>
